export default {
  SET_STATUS(state, { progress, condition_id, status }) {
    const conditions = { ...state.conditionsBeingActivated }
    conditions[condition_id].progress = progress
    conditions[condition_id].status = status
    state.conditionsBeingActivated = conditions
  },
  REMOVE_PROGRESS(state, condition_id) {
    const conditions = { ...state.conditionsBeingActivated }
    Reflect.deleteProperty(conditions, condition_id)
    state.conditionsBeingActivated = conditions
  },
  SET_JOB_DETAILS(state, { name, uuid, progress, condition_id }) {
    const conditions = { ...state.conditionsBeingActivated }
    conditions[condition_id] = { name, uuid, progress }
    state.conditionsBeingActivated = conditions
  },
}
